<template>
  <div>
    <table-education-level
      :table-headers="tableHeaders"
      :flat-headers="flatHeaders"
    >
      <tr
        class="table__tr"
        v-for="(abiturient, index) in filteredAbiturients"
        :key="abiturient.id"
        :class="{
          'table__tr--budget': contest_group.places === index+1,
          'table__tr--budget-with-quota': false && contest_group.budget_places_with_free_quota === index+1
        }"
      >
        <td
          class="table__td"
          v-for="header in flatHeaders"
          :key="header.value"
        >
          <template v-if="header.value === 'index'">
            {{ index + 1 }}
          </template>
          <template v-else-if="abiturient.without_exam && isExamRelatedField(header.value)">
            -
          </template>
          <template v-else-if="abiturient.without_exam && header.value === 'rating'">
            БВИ
          </template>
          <template v-else-if="header.value === 'has_agreement'">
            {{ abiturient[header.value] ? 'Да' : 'Нет' }}
          </template>
          <template v-else-if="header.value === 'is_highest_priority'">
            {{ abiturient[header.value] ? 'Да' : 'Нет' }}
          </template>
          <template v-else-if="header.value === 'is_highest_passing_priority'">
            {{ abiturient[header.value] ? 'Да' : 'Нет' }}
          </template>
          <template v-else-if="header.value === 'has_contract'">
            {{ abiturient[header.value] ? 'Да' : 'Нет' }}
          </template>
          <template v-else>
            {{ abiturient[header.value] ? abiturient[header.value] : '-' }}
          </template>
        </td>
      </tr>
    </table-education-level>
  </div>
</template>

<script>
import GroupsMixin from '@main/mixins/groups'

export default {
  mixins: [GroupsMixin],
}
</script>